import { useContext } from 'react';
import { LanguageContext } from '@/contexts/LanguageContext';
import { useNavigate, useLocation } from 'react-router-dom';

export const useTranslation = () => {
  const { language, setLanguage, translations } = useContext(LanguageContext);
  const navigate = useNavigate();
  const location = useLocation();

  const t = (key) => {
    const keys = key.split('.');
    let value = translations;
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key;
      }
    }
    return value || key;
  };

  const changeLanguage = (lang) => {
    if (lang === language) return;
    setLanguage(lang);
    
    // Update URL prefix
    const pathParts = location.pathname.split('/');
    if (['pt', 'en', 'es'].includes(pathParts[1])) {
      pathParts[1] = lang;
    } else {
      pathParts.unshift('', lang);
    }
    const newPath = pathParts.join('/').replace('//', '/') + location.search + location.hash;
    navigate(newPath, { replace: true });
  };

  return { t, currentLanguage: language, changeLanguage, supportedLanguages: ['pt', 'en', 'es'] };
};